<template>
  <div id="comboboxColorbox">
    <v-combobox
      v-model="value"
      hint="Renkleri eklemek için 'Renk Ekle' butonuna basın ve paletten renk seçimi yapın"
      persistent-hint
      @change="addItem"
      multiple
      chips
      outlined
      filled
      readonly
    >
      <template v-slot:selection="{ attrs, item, selected }">
        <v-chip
          v-bind="attrs"
          :input-value="selected"
          color="white"
          class="elevation-3"
          label
        >
          <span class="pr-2">
            <v-sheet
              rounded="circle"
              width="20px"
              height="20px"
              :color="item"
              elevation="2"
            ></v-sheet>
          </span>
          <v-icon size="15" class="mx-1" @click="editItem(item)">
            mdi-pencil
          </v-icon>
          <v-icon size="17" @click="deleteItem(item)"> mdi-close </v-icon>
        </v-chip>
      </template>
      <template v-slot:append>
        <v-btn small color="purple darken-1" rounded dark @click="dialog = true">
          <v-icon small left>mdi-sticker-plus</v-icon>
          Renk Ekle
        </v-btn>
      </template>
    </v-combobox>
    <div id="comboboxDialog">
      <v-dialog
        v-model="dialog"
        max-width="435"
        transition="dialog-bottom-transition"
      >
        <div id="colorBoxPicker">
          <v-row class="mx-0">
            <v-col>
              <v-card elevation="5">
                <v-color-picker
                  dot-size="25"
                  :mode="mode"
                  show-swatches
                  swatches-max-height="200"
                  v-model="adding"
                  :hide-mode-switch="hideModeSwitch"
                ></v-color-picker>
              </v-card>
            </v-col>
            <v-col class="px-0 d-flex flex-column align-center">
              <v-btn v-if="!editing" fab dark color="blue" class="mb-3" @click="addColor">
                <v-icon>mdi-check</v-icon>
              </v-btn>
              <v-btn v-else fab dark color="pink darken-3" class="mb-3" @click="edit">
                <v-icon>mdi-pencil</v-icon>
              </v-btn>
              <v-btn
                fab
                dark
                small
                color="red darken-2"
                @click="dialog = false"
              >
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </div>
      </v-dialog>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import TinyColor from 'tinycolor2'

export default {
  name: "ColorBox",
  props: {
    value: {
      type: Array,
    },
    mode: {
      default: "hexa",
      type: String,
    },
    hideModeSwitch: {
      default: false,
      type: Boolean,
    }
  },
  data() {
    return {
      editing: false,
      adding: "",
      dialog: false,
      // rules: {
      //   isValid: (value) => TinyColor(value).isValid() || "Geçerli bir renk formatı girin"
      // }
    };
  },
  methods: {
    addItem(item) {
      if (TinyColor(item).isValid()) {
        this.items = item;
      } else false
    },
    addColor() {
      if (!this.value.includes(this.adding)) this.value.push(this.adding);
      this.closeDialog()
    },
    editItem(item) {
      // Düzenlemeyi al
      this.editing = item;
      // Düzenlenirken adding üzerine ekle
      this.adding = this.editing
      // Diyaloğu aç
      this.openDialog()
    },
    edit() {
      let comboboxData = this.value.map(item => {
        if (item === this.editing) return this.adding
        return item
      });
      this.emitCombobox(comboboxData)
      this.closeDialog()
      this.editing = false
    },
    openDialog() {
      this.dialog = true;
    },
    closeDialog() {
      this.dialog = false
    },
    emitCombobox(value) {
      this.$emit('change', value)
    },
    /**
     * Renk silme işlemi yap
     */
    deleteItem(item) {
      let comboboxData = []
      if (this.value.length > 1) {
        comboboxData = _.remove(this.value, color => {
          return color !== item 
        })
      }
      this.emitCombobox(comboboxData)
    }
  },
  watch: {
    dialog(value) {
      if (value === false) {
        // Dialog kapandığında ilgili ayarları sıfırla
        this.editing = ''
        this.adding = ''
      }
    }
  }
};
</script>

<style lang="sass">
.v-dialog
  box-shadow: none
</style>